export default "__VITE_ASSET__CTCkiTar__"